
import { CustomAutocomplete, CustomAutocompleteArrString, GeneralTable } from "@/shared/components/ui";
import { Grid, IconButton, } from "@mui/material";
import { gridSizeMdLg5, ModulosEnumChoice, ModulosMotivoENUM, PRIORIDAD_INCIDENCIA_CHOICE, TABLE_CONSTANTS, useTableFilter, useTableServerSideFiltering } from '@/shared';
import { useEffect, useState } from "react";
import { useDiccionarioMotivo } from "@/store/erp/diccionario_motivo/diccionario_motivo.store";
import { EstadoBitacoraEnum, IDataBitacoraResp, Venta } from "@/shared/interfaces";
import { useTableColumnsBitacora } from "./useTableColumnsBitacora";
import { useFetchMotivos } from "@/shared/actions/erp";
import { IDataMotivo } from "@/shared/interfaces/erp/inventario/motivo.interface";
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import { useForm } from "react-hook-form";
import { useAuthStore } from "@/store/auth";
import { Refresh } from "@mui/icons-material";

interface TableBitacoraComponente {
  prioridad: string | null
  motivo: string | null
}

interface TableBitacoraComponenteProps {
  estado_bitacora: EstadoBitacoraEnum,
  enable_action: boolean
  disabledAction?: boolean
}
interface DiccionarioMotivo {
  fase_venta?: string;
}

export default function TableBitacoraComponenteVenta({
  estado_bitacora,
  enable_action = true,
  disabledAction = false
}: TableBitacoraComponenteProps) {
  const infoUser = useAuthStore(s => s.user)

  const [dataBitacora, setDataBitacora] = useState<IDataBitacoraResp | null>(null);
  const [detalleDiccionarioMotivo, setDetalleMotivo] = useState<DiccionarioMotivo[]>([])


  const form = useForm<TableBitacoraComponente>({
    defaultValues: {
      prioridad: null,
      motivo: null
    }
  })
  const {
    formState: { errors },
  } = form


  const {
    sorting,
    setSorting,
    pagination,
    setPagination
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  const {
    filterObject,
    columnFilters, setColumnFilters
  } =
    useTableServerSideFiltering();

  ///* socket
  const {
    setFaseVenta,
    socket
  } = useDiccionarioMotivo()


  const { data: dataMotivos, isLoading: isLoadingMotivo
  } = useFetchMotivos({
    estado: true,
    modulo_in: `${ModulosMotivoENUM.BITACORA_VENTA},${ModulosMotivoENUM.BITACORA_PYL}`,
    page_size: 256,
  })


  const numero_referencia_motivo = form.watch('motivo')
  const prioridad = form.watch('prioridad')

  useEffect(() => {

    if (!socket) return

    handleVentas()

    socket.on('getVentas', (response: IDataBitacoraResp) => {
      if (response.code == 200) {
        //console.log(response.data.data);
        setDataBitacora(response)
      } else {
        console.log("Error al obtener los datos")
      }
    })


    return () => {
      socket.off('getVentas')
    }
  }, [pageIndex, pageSize,
    numero_referencia_motivo,
    prioridad, filterObject,
    sorting])



  useEffect(() => {
    if (detalleDiccionarioMotivo.length > 0) {
      const agendamiento = detalleDiccionarioMotivo.find((item) => item.fase_venta === ModulosEnumChoice.AGENDAMIENTO)

      if (agendamiento) {
        setFaseVenta(ModulosEnumChoice.AGENDAMIENTO)
      } else {
        const preAgendamiento = detalleDiccionarioMotivo.find(item => item.fase_venta === ModulosEnumChoice.PREAGENDAMIENTO)
        if (preAgendamiento) {
          setFaseVenta(ModulosEnumChoice.PREAGENDAMIENTO)
        } else {
          setFaseVenta(ModulosEnumChoice.ORDEN_TRABAJO)
        }
      }
    }
  }, [detalleDiccionarioMotivo])

  const handle = (value: any) => {
    setDetalleMotivo(value.diccionario_motivo)
  }

  const handleVentas = () => {

    if (!socket) return

    const primarySort = sorting[0];

    let ordenamiento = {}

    if (primarySort) {
      ordenamiento = {
        sortBy: primarySort.id,
        sortDir: primarySort.desc ? "desc" : "asc",
      }
    }


    let permisos: any = {}

    if (infoUser?.rol == 'SUPERVISOR') {
      permisos = {
        canal_venta: infoUser.canal_venta,
      }
    } else {
      permisos = {
        vendedor: infoUser?.username,
      }
    }

    console.log(filterObject);

    socket.emit("getVentasFilter", {
      page: pageIndex + 1,
      pageSize: pageSize,
      filtros: {
        numero_referencia_motivo: numero_referencia_motivo,
        prioridad: prioridad,
        estado_bitacora,
        ...permisos,
        ...ordenamiento,
        ...filterObject,
      }
    })
  }

  const { columnsBitacoraVenta } = useTableColumnsBitacora({
    handle,
    disabledAction
  })

  return (
    <>

      <Grid container spacing={2} >

        <CustomAutocomplete<IDataMotivo>
          label="Motivo"
          name="motivo"
          // options
          options={dataMotivos?.data.data || []}
          valueKey="nombre"
          actualValueKey="id_motivo"
          defaultValue={form.getValues().motivo || ''}
          isLoadingData={isLoadingMotivo}
          // validation
          control={form.control}
          error={errors.motivo}
          helperText={errors.motivo?.message}
          size={gridSizeMdLg5}
          required={false}
        />

        <CustomAutocompleteArrString
          label="Prioridad"
          name="prioridad"
          options={PRIORIDAD_INCIDENCIA_CHOICE}
          control={form.control}
          defaultValue={form.getValues().prioridad || ''}
          error={errors.prioridad}
          helperText={errors.prioridad?.message?.toString() ?? ''}
          isLoadingData={false}
          size={gridSizeMdLg5}
          required={false}
        />

        <Grid item xs={2}>
          <IconButton onClick={() => {
            form.reset({})
          }}>
            <FilterAltOffIcon />
          </IconButton>

          <IconButton onClick={() => {
            //form.reset({})
            handleVentas();
          }}>
            <Refresh />
          </IconButton>

        </Grid>

        <Grid item xs={12}>
          <GeneralTable<Venta>
            data={dataBitacora?.data.data || []}
            columns={columnsBitacoraVenta}
            isLoading={false}
            isRefetching={false}
            enableGlobalFilter={false}
            ///* pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={dataBitacora?.data.count}
            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            positionActionsColumn="first"
            canDelete={false}
            canEdit={false}
            enableEditing={enable_action}
            ///* ordenar
            manualSorting={true}
            enableSorting={true}
            sorting={sorting}
            onSortingChange={setSorting}
            //
            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_SMALL}
            showCustomActionBtnSpace={enable_action}
          />
        </Grid>
      </Grid>
    </>
  )

}